import { Tax } from "../modules/tax";

export const TaxPage = () => {
  return <Tax />;
};
